import { render } from "./index.vue?vue&type=template&id=3d07d9c9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=3d07d9c9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3d07d9c9"

export default script